import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { AnalysisService } from './services/analysis.service';
import { FileService } from './services/file.service';
import { FeedbackService } from './services/feedback.service';
import { DownloadFileService } from './services/download-file.service';
import { LogService } from './services/log.service';
import { I18nModule } from './i18n/i18n.module';

@NgModule({
  imports: [RouterModule, MatDialogModule, I18nModule],
  exports: [RouterModule, MatDialogModule],
  providers: [AnalysisService, FileService, FeedbackService, DownloadFileService, LogService],
})
export class SharedModule {}
